module.exports = __webpack_public_path__ + "static/media/check.9b8c9fbc.png";